<div class="dots-container">
  <div class="dots-container__dot first"></div>
  <div class="dots-container__dot second"></div>
  <div class="dots-container__dot third"></div>
</div>
